var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-card-skeleton"},[_c('div',{staticClass:"card-icon"}),_c('div',{staticClass:"card-body"}),_c('div',{staticClass:"date-box"},[_c('div',{staticClass:"card-date"}),_c('div',{staticClass:"card-date"})])])
}]

export { render, staticRenderFns }